module.exports = __webpack_public_path__ + "img/vegetable-sunchokes-350x184.f2cec4a2.jpg";